import { Button, Paper } from '@material-ui/core'
import { IVendorEvaluation } from '../../../../api/smartbestbuys-api'
import { SubTopic, Table } from '../../../../custom-components'
import { dateTimeFormat } from '../../../../functions'
import { useState } from 'react'
import VendorEvaluationCreateDialog from './VendorEvaluationCreateDialog'

interface Props {
  vendorId: number
  vendorEvaluations: IVendorEvaluation[]
  reloadEvaluation: () => void
}

const VendorEvaluationBox = (props: Props) => {
  const { vendorId, vendorEvaluations, reloadEvaluation } = props
  const [evaluationOpen, setEvaluationOpen] = useState<boolean>(false)
  return (
    <Paper>
      <VendorEvaluationCreateDialog
        open={evaluationOpen}
        vendorId={vendorId}
        onClose={() => {
          setEvaluationOpen(false)
        }}
        onComplete={() => {
          setEvaluationOpen(false)
          if (!!reloadEvaluation) reloadEvaluation()
        }}
      />
      <div className="flex justify-between">
        <SubTopic>ประวัติคะแนนผู้ขาย</SubTopic>
        <Button
          color="primary"
          variant="contained"
          onClick={() => {
            setEvaluationOpen(true)
          }}
        >
          ประเมินผู้ขาย
        </Button>
      </div>

      <div className="mb-2" />
      <Table<IVendorEvaluation>
        color="primary.dark"
        size="small"
        columns={[
          { name: 'คะแนน', dataIndex: 'evaluationScore' },
          { name: 'หมายเหตุ', dataIndex: 'remark' },
          { name: 'จัดการโดย', dataIndex: 'recCreatedBy' },
          {
            name: 'วันที่',
            render: (ua) => dateTimeFormat(ua.recCreatedAt),
          },
        ]}
        data={vendorEvaluations}
        rowsPerPage={5}
        cleanSpace
      />
    </Paper>
  )
}

export default VendorEvaluationBox
